import {EventItem} from "../event-item";
import {Race} from "../race";
import {RaceCommercialItem} from "../race-commercial-item";
import {RaceAdditionalPricingItem} from "../race-additional-pricing-item";

export class WspayConfirmation {
  eventName?:string;
  eventNameEng?:string;
  eventNameIta?:string;
  eventNameSlo?:string;
  eventNameSr?:string;
  eventNameBs?:string;
  eventDefaultLang?:number;
  eventStart?:Date;
  paymentStatus?: PaymentStatus;
  totalAmount?: number;
  totalAmountWithDiscount?: number;
  currencyCode?:string;
  created?: Date;
  event?:EventItem;
  race?:Race;
  competitors?: CompetitorInfoDTO[];
}

export class CompetitorInfoDTO {
  teamMember?:boolean;
  firstName?:string;
  lastName?:string;
  fullName?:string;
  email?:string;
  raceCommercialItem?:RaceCommercialItem;
  raceAdditionalPricingItems?:RaceAdditionalPricingItem[];
}

export enum PaymentStatus {
  NO_PAYMENT,
  PENDING,
  SUCCESS,
  CANCEL,
  ERROR
}
